import { useStockStatusMessage } from '@/hooks/StockStatusMessage/useStockStatusMessage';

import { useStyle } from '@/classify';
import defaultClasses from './stockStatusMessage.module.css';

const StockStatusMessage = props => {
  const {
    cartItems,
    messageId = 'stockStatusMessage.message',
    message = 'An item in your cart is currently out-of-stock and must be removed in order to Checkout.',
  } = props;
  const classes = useStyle(defaultClasses, props.classes);

  const talonProps = useStockStatusMessage({
    cartItems,
  });
  const { hasOutOfStockItem } = talonProps;

  const stockStatusMessageElement = hasOutOfStockItem ? <div className={classes.root}>{message}</div> : null;

  return stockStatusMessageElement;
};

export default StockStatusMessage;
